(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-info/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/cookies-info/assets/javascripts/init.js'); 
'use strict';

if (window.location.pathname.indexOf('/villkor-och-integritet') < 0) {
  var _svs, _svs$core, _svs$core$config, _svs$core$config$data, _svs$core$config$data2, _svs$core$config$data3;
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ? svs.core.config.data.svsconfig.isNativeApp : false;
  const isIos = svs.utils.ns.isNamespace('svs.core.detect.os') && typeof svs.core.detect.os.iOS === 'function' ? svs.core.detect.os.iOS() : false;

  const iOsTrackingQsParam = svs.utils.paramHandler.get({
    key: 'userTrackingAllowed'
  }).value || '';
  const isIosUserTrackingAllowed = Boolean(iOsTrackingQsParam === '1' || iOsTrackingQsParam.toLowerCase() === 'true');

  const cookieDialogInfoObject = {
    corporateName: 'AB Svenska Spel',
    corporateUrl: 'svenskaspel.se',
    branding: svs.components.dialog.branding.NEUTRAL,
    cookieInfoUrl: "https://www.svenskaspel.se".concat(svs.core.urlMapping.get('termsIntegrityCookies')),
    personalDataUrl: "https://www.svenskaspel.se".concat(svs.core.urlMapping.get('termsIntegrityPersonData')),
    isTrackingAllowed: !isNativeApp || !isIos || isIosUserTrackingAllowed
  };
  if (((_svs = svs) === null || _svs === void 0 ? void 0 : (_svs$core = _svs.core) === null || _svs$core === void 0 ? void 0 : (_svs$core$config = _svs$core.config) === null || _svs$core$config === void 0 ? void 0 : (_svs$core$config$data = _svs$core$config.data) === null || _svs$core$config$data === void 0 ? void 0 : (_svs$core$config$data2 = _svs$core$config$data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : (_svs$core$config$data3 = _svs$core$config$data2.site) === null || _svs$core$config$data3 === void 0 ? void 0 : _svs$core$config$data3.toLowerCase()) === 'momang') {
    cookieDialogInfoObject.corporateName = 'Svenska Spel Sport & Casino AB';
    cookieDialogInfoObject.corporateUrl = 'www.momangcasino.se';
    cookieDialogInfoObject.branding = svs.components.dialog.branding.MOMANG;
    cookieDialogInfoObject.cookieInfoUrl = svs.core.urlMapping.get('termsIntegrityCookies');
    cookieDialogInfoObject.personalDataUrl = svs.core.urlMapping.get('termsIntegrityPersonData');
  } else if (svs.core.detect.tenant('tb')) {
    cookieDialogInfoObject.corporateName = 'AB Svenska Spel';
    cookieDialogInfoObject.corporateUrl = 'svenskaspel.se/tur';
    cookieDialogInfoObject.branding = svs.components.dialog.branding.TUR;
    cookieDialogInfoObject.cookieInfoUrl = svs.core.urlMapping.get('termsIntegrityCookies');
    cookieDialogInfoObject.personalDataUrl = svs.core.urlMapping.get('termsIntegrityPersonData');
  } else if (svs.core.detect.tenant('lb')) {
    cookieDialogInfoObject.corporateName = 'Svenska Spel Sport & Casino AB';
    cookieDialogInfoObject.corporateUrl = 'spela.svenskaspel.se';
    cookieDialogInfoObject.branding = svs.components.dialog.branding.SPORT;
    cookieDialogInfoObject.cookieInfoUrl = svs.core.urlMapping.get('termsIntegrityCookies');
    cookieDialogInfoObject.personalDataUrl = svs.core.urlMapping.get('termsIntegrityPersonData');
  } else if (svs.core.detect.tenant('mb')) {
    cookieDialogInfoObject.corporateName = 'AB Svenska Spel';
    cookieDialogInfoObject.corporateUrl = 'partner.svenskaspel.se';
    cookieDialogInfoObject.branding = svs.components.dialog.branding.NEUTRAL;
    cookieDialogInfoObject.cookieInfoUrl = "https://www.svenskaspel.se".concat(svs.core.urlMapping.get('termsIntegrityCookies'));
    cookieDialogInfoObject.personalDataUrl = "https://www.svenskaspel.se".concat(svs.core.urlMapping.get('termsIntegrityPersonData'));
  }
  document.addEventListener('DOMContentLoaded', () => {
    svs.components.cookies_info.cookieInfo.show(cookieDialogInfoObject);
  });
}
 })(window);